import { render } from "./createMessageDialog.vue?vue&type=template&id=6edd84a6&scoped=true"
import script from "./createMessageDialog.vue?vue&type=script&lang=js"
export * from "./createMessageDialog.vue?vue&type=script&lang=js"

import "./createMessageDialog.vue?vue&type=style&index=0&id=6edd84a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edd84a6"]])

export default __exports__